import React from 'react';
import {useTheme} from '../../../theme';
import {BaseDropTargetLayout} from './BaseDropTargetLayout';
import {mapToBaseProperties} from '../functions';
import {DragableItem, DropTargetLayoutProps} from '../types';

/**
 * Note: DropTargetLayout cannot be inside and LayoutScrollable
 * @param props
 */
export const DropTargetLayout = function <TItem extends DragableItem>(
  props: React.PropsWithChildren<DropTargetLayoutProps<TItem>>,
) {
  const {
    type,
    enabled,
    onBeginHover,
    onHover,
    onEndHover,
    onDrop,
    onPress,
    children,
    ...rest
  } = props;
  const theme = useTheme();

  const baseProps = mapToBaseProperties(theme, rest);

  return (
    <BaseDropTargetLayout
      type={type}
      enabled={enabled}
      onPress={onPress}
      onBeginHover={onBeginHover}
      onHover={onHover}
      onEndHover={onEndHover}
      onDrop={onDrop}
      {...baseProps}>
      {children}
    </BaseDropTargetLayout>
  );
};
